import { render, staticRenderFns } from "./FormatPopover.vue?vue&type=template&id=37297280"
import script from "./FormatPopover.vue?vue&type=script&lang=js"
export * from "./FormatPopover.vue?vue&type=script&lang=js"
import style0 from "./FormatPopover.vue?vue&type=style&index=0&id=37297280&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports